import {i18n} from "../plugins/vue-i18n";
import dateConverter from "../utils/converters/date.converter";

export default {
  methods: {
    buildErrorMessage(er) {
      // Get errors text for current culture
      const errorsDictionary = i18n.t('ERRORS');

      // Define default value
      var errorMessage = er.message;

      // Search error in dictionary
      for (const errorType in errorsDictionary)
      {
        if (errorType != er.errorType) continue;

        // Get needed error type
        const errorPattern = errorsDictionary[errorType];

        // Combine message
        errorMessage = errorPattern;
        for (const parameterKey in er.parameters) {
          const parameterType = er.parameters[parameterKey].type;

          // Converting value by type
          let parameterValue = er.parameters[parameterKey].value;
          switch (parameterType)
          {
            case 'DateWithoutTime':
              parameterValue = this.$d(dateConverter.convertToDate(parameterValue));
              break;
            case 'PaymentKind':
              parameterValue = this.$t('CONTENT.payments.' + parameterValue);
              break;
            case 'IndexationType':
              switch (parameterValue)
              {
                case '1': parameterValue = this.$t('CONTENT.indexation.first_type'); break;
                case '2': parameterValue = this.$t('CONTENT.indexation.second_type'); break;
                case '3': parameterValue = this.$t('CONTENT.indexation.third_type'); break;
                case '4': parameterValue = this.$t('CONTENT.indexation.forth_type'); break;
              }
              break;
            case 'EventType':
              parameterValue = this.$t('CONTENT.events.' + parameterValue);
              break;
            case 'Type':
              parameterValue = parameterValue.replace('JsonModel', '');
              parameterValue = parameterValue.replace('Model', '');
              parameterValue = this.$t('CONTENT.className.' + parameterValue);
              break;
            default:
              // Its for primitive types and some ValueObjects
              parameterValue = parameterValue.toString();
              break;
          }

          // Insert converted value into message
          errorMessage = errorMessage.replace(new RegExp("\{" + parameterKey + "\}", "gi"), parameterValue);
        }
      }

      // Add inner error to message
      if (er.innerError)
        errorMessage = errorMessage + ': ' + this.buildErrorMessage(er.innerError);

      return errorMessage;
    }
  }
};
